<template>
  <div>
    <el-card>
      <el-tabs v-model="project_index" type="card" editable @edit="handleProjectTabsEdit" @tab-click="ad_index = '0'">
        <el-tab-pane
          v-for="(project_item, p_index) in project_batch_params"
          :key="p_index"
          :label="project_item.basic_set_form.config.name.value || `项目${p_index + 1}`"
          :name="`${p_index}`"
        >
          <project-batch
            :ref="'projectRef'"
            :project-data="project_item"
            :project-config="project_config"
            @forceUpdateDistrict="initDistrictTasks"
          />
          <el-tabs v-if="project_item.advertiser_id" v-model="ad_index" type="card" editable @edit="handleAdTabsEdit">
            <el-tab-pane
              v-for="(ad_item, index) in project_item.promotion_batch_params"
              :key="index"
              :label="ad_item.name || `广告${index + 1}`"
              :name="`${index}`"
            >
              <ad-batch
                :ref="'adRef'"
                :ad-data="ad_item"
                :ad-config="{ ...project_item, project_index: p_index, ad_index: index }"
              />
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>
      </el-tabs>
      <div v-if="project_batch_params[project_index]?.advertiser_id" style="text-align: center; margin-top: 20px;">
        <el-button type="primary" plain style="margin-right: 10px" @click="reset">重置</el-button>
        <el-button type="primary" @click="submit">提交</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>

import ConfigResource from '@/api/config';
const configResource = new ConfigResource();

import AdvertisingResource from '@/api/advertising';
const advertisingResource = new AdvertisingResource();

import UpgradePlanResource from '@/api/upgradePlan/jrtt';
const upgradePlanResource = new UpgradePlanResource();

import { getMediasListApi } from '@/api/medias';

import getJrttProjectConfig from '@/tools/form/model/jrtt/project-config';

import { getDistrictApi } from '@/api/tool/district/jrtt';
import { clone } from '@/utils';

export default {
  components: {
    'project-batch': () => import('./components/project-batch.vue'),
    'ad-batch': () => import('./components/ad-batch.vue'),
  },
  provide() {
    return {
      aweme_id_map: {},
      sharing_districts_map: this.districts_map,
    };
  },
  data() {
    return {
      /** 当前项目标签页下标 */
      project_index: '0',
      /** 批量项目表单项 */
      project_batch_params: [],
      /** 批量项目提交参数 */
      project_submit_params: [],
      /** 项目配置 */
      project_config: {
        /** 通用表单选项 */
        project_form_option: {
          /** 广告主账号选项 */
          advertiser_id_option: [],

          /** 渠道表单选项 */
          type1: [], // 渠道类型
          game_id: [], // 游戏
          pack_ad_account: [], // 分包广告商户ID
        },
      },
      /** 当前广告标签页下标 */
      ad_index: '0',
      districts_map: {},
    };
  },
  watch: {
    project_batch_params: {
      handler(newVal) {
        const copy_data = clone(newVal);
        /** 不持久化存储地域数据 */
        copy_data.forEach(({ audience_form }) => audience_form.config.audience.children.city.options?.splice(0));
        localStorage.setItem('batch_plan', JSON.stringify(copy_data));
      },
      deep: true,
    },
  },
  created() {
    const getStorage = localStorage.getItem('batch_plan');
    if (getStorage) {
      // 获取本地数据
      this.project_batch_params = JSON.parse(getStorage);
    } else {
      // 初始化项目，广告表单项
      this.project_batch_params.push(this.newsProjectForm());
      this.project_batch_params[this.project_index].promotion_batch_params.push(this.newsAdForm());
    }

    this.getMediasList();
    this.getChannelType1List();
    this.getChannelGameIdList();
    this.getchannelPackAdAccountList();
    this.initDistrictTasks();
  },
  beforeDestroy() {
    localStorage.removeItem('batch_plan');
  },
  methods: {
    /** 获取广告账号列表 */
    getMediasList() {
      getMediasListApi({
        type: 'jrtt',
        is_list: true,
      }).then((res) => {
        this.project_config.project_form_option.advertiser_id_option = res.list.map((accoun_item) => {
          return {
            label: `${accoun_item.advertiser_id}(${accoun_item.advertiser_name})${accoun_item.note ? ' - ' + accoun_item.note : ''}`,
            value: accoun_item.advertiser_id,
          };
        });
      });
    },
    /** 获取渠道类型列表 */
    async getChannelType1List() {
      const response = await configResource.getConfigDataApi({ module: 'ad', key: 'jrtt_channel_type1' });
      this.project_config.project_form_option.type1 = response.map((item) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
    },
    /** 获取渠道 - 游戏列表 */
    async getChannelGameIdList() {
      const response = await advertisingResource.getGameListApi({ refresh: 1 });
      const { list } = response;
      this.project_config.project_form_option.game_id = list;
    },
    /** 获取分包广告商户ID列表 */
    async getchannelPackAdAccountList() {
      const response = await configResource.getConfigDataApi({ module: 'ad', key: 'jrtt_pack_account' });
      this.project_config.project_form_option.pack_ad_account = response.map((item) => {
        return {
          label: `${item.label}  -  ${item.note}`,
          value: item.id,
        };
      });
    },
    /** 项目标签添加删除事件 */
    handleProjectTabsEdit(targetName, action) {
      const length = this.project_batch_params.length;
      if (action === 'add') {
        if (length === 10) {
          this.$message.warning('项目数量上限为10个！');
          return;
        }
        this.project_batch_params.push(this.newsProjectForm());
        this.project_batch_params[length].promotion_batch_params.push(this.newsAdForm());
      } else {
        this.$confirm('是否确认删除该项目？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.project_batch_params.splice(targetName, 1);
          this.project_index = '0';
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
        });
      }
    },
    /** 广告标签添加删除事件 */
    handleAdTabsEdit(targetName, action) {
      if (action === 'add') {
        const length = this.project_batch_params[this.project_index].promotion_batch_params.length;
        if (length === 10) {
          this.$message.warning('广告数量上限为10个！');
          return;
        }
        this.project_batch_params[this.project_index].promotion_batch_params.push(this.newsAdForm());
      } else {
        this.$confirm('是否确认删除该广告？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.project_batch_params[this.project_index].promotion_batch_params.splice(targetName, 1);
          this.ad_index = '0';
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
        });
      }
    },
    /** 重置 */
    reset() {
      this.$confirm('重置将清空所有项目和广告，确定重置？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.project_batch_params.splice(0);
        this.project_index = '0';
        this.ad_index = '0';
        this.$nextTick(() => {
          this.project_batch_params.push(this.newsProjectForm());
          this.project_batch_params[this.project_index].promotion_batch_params.push(this.newsAdForm());
        });
      }).catch(() => {});
    },
    /** 提交批量项目 */
    async submit() {
      this.project_submit_params = [];
      for (let i = 0; i < this.$refs.projectRef.length; i++) {
        const is_succeed = await this.$refs.projectRef[i].validateAllForm();
        if (is_succeed) {
          const { project_template, projectData } = this.$refs.projectRef[i];
          const { alias: { extra_data } = {}} = projectData.channel_form.config.channel.children;
          const { channel_details = {}} = extra_data;
          const { alias: channel_alias, config: { platform } = {}, game_id } = channel_details;
          const { alias = channel_alias } = project_template.channel;
          // 格式化项目名称
          project_template.name += `-jrttnew+${alias}++${platform}+${game_id}`;
          this.project_submit_params.push(project_template);
        } else {
          this.project_index = `${i}`;
          return;
        }
      }
      for (let i = 0; i < this.$refs.adRef.length; i++) {
        const is_succeed = await this.$refs.adRef[i].validateAllForm();
        const { project_index, ad_index } = this.$refs.adRef[i].adConfig;
        const { ad_template } = this.$refs.adRef[i];
        if (!is_succeed) {
          this.project_index = `${project_index}`;
          this.ad_index = `${ad_index}`;
          return;
        }
        if (!ad_template.name) {
          this.$message.warning('请输入广告名称');
          this.project_index = `${project_index}`;
          this.ad_index = `${ad_index}`;
          return;
        }
      }
      // 根据项目名称匹配广告数据
      this.project_submit_params.forEach(project_item => {
        project_item.promotion_batch_params = [];
        this.$refs.adRef.forEach(ad_item => {
          if (project_item.name === ad_item.ad_template.project_name) {
            project_item.promotion_batch_params.push(ad_item.ad_template);
            delete ad_item.ad_template.project_name;
          }
        });
      });
      upgradePlanResource.upgradeBatchCreatPlanApi({ project_batch_params: this.project_submit_params }).then(e => {
        this.$message.success(e.message);
      });
    },
    /** 生成新的项目表单项 */
    newsProjectForm() {
      return {
        // 广告主ID
        advertiser_id: '',
        project_config: {
          ad_wildcard: {
            // 定向包模板名称
            audience_template_name: '',
            // 广告版位模板名称
            delivery_range_template_name: '',
          },
        },
        // 基础设置
        basic_set_form: {
          title: '基础设置',
          config: getJrttProjectConfig([
            'landing_type',
            'app_promotion_type',
            'delivery_mode',
            'marketing_goal',
            'ad_type',
            'name',
          ]),
        },
        // 广告版位
        delivery_range_form: {
          hidden: false,
          title: '广告版位',
          config: getJrttProjectConfig([
            'delivery_range',
          ]),
        },
        // 渠道
        channel_form: {
          title: '渠道',
          config: getJrttProjectConfig([
            'channel',
          ]),
        },
        // 投放内容与目标
        target_form: {
          title: '投放内容与目标',
          config: getJrttProjectConfig([
            'platform',
            'download_url',
            'download_type',
            'download_mode',
            'launch_type',
            'open_url',
            'ulink_url',
            'subscribe_url',
            'micro_promotion_type',
            'micro_app_instance_id',
          ]),
        },
        // 优化目标
        optimize_form: {
          title: '优化目标',
          config: getJrttProjectConfig([
            'optimize_goal',
          ]),
        },
        // 排期与预算
        delivery_setting_form: {
          title: '排期与预算',
          config: getJrttProjectConfig([
            'delivery_setting',
          ]),
        },
        // 定向包
        audience_form: {
          title: '定向包',
          config: getJrttProjectConfig([
            'audience',
          ]),
        },
        // 批量广告配置
        promotion_batch_params: [],
      };
    },
    /** 生成新的广告表单项 */
    newsAdForm() {
      return {
        // 广告名称
        name: '',
        // 广告状态
        operation: {
          label: '广告状态',
          value: 'DISABLE',
          options: [
            { label: '开启', value: 'ENABLE' },
            { label: '关闭', value: 'DISABLE' },
          ],
        },
        // 推广身份
        native_form: {
          title: '推广身份（原生广告）',
          config: {
            native_setting: {
              value: {},
              children: {
                promotion_identity: {
                  label: '推广身份',
                  type: 'radio-group',
                  isButton: true,
                  is_filter: true,
                  options: [
                    { label: '抖音号', value: 'TIKTOK' },
                    { label: '账户信息', value: 'ACCOUNT_INFO' },
                  ],
                  value: 'ACCOUNT_INFO',
                  rules: [
                    { required: true, message: '请选择原生锚点', trigger: ['blur', 'change'] },
                  ],
                },
                aweme_id: {
                  label: '授权账号',
                  type: 'select',
                  hidden: true,
                  props: {
                    style: {
                      width: '200px',
                    },
                    loading: false,
                  },
                  value: '',
                  options: [],
                  rules: [
                    { required: true, message: '请选择授权账号', trigger: ['blur', 'change'] },
                  ],
                },
              },
            },
          },
        },
        // 广告素材-表单配置
        material_form: {
          title: '广告素材',
          config: {
            promotion_materials: {
              value: {},
              children: {
                material: {
                  label: '添加素材',
                  // 限制数量
                  limit: 10,
                  is_open: false,
                  box_type: 'video',
                  temp_material: null,
                  rules: {
                    required: true, trigger: [],
                    validator: (rule, value, callback) => {
                      if (value.videos.length !== 0 || value.images.length !== 0) {
                        callback();
                      } else {
                        callback(new Error('请选择素材'));
                      }
                    },
                  },
                  value: {
                    videos: [],
                    images: [],
                    tab: 'video',
                  },
                },
                // 标题素材
                title: {
                  label: '标题',
                  is_open: false,
                  rules: [
                    {
                      required: true, message: '请选择标题', trigger: [],
                      validator: (rule, value, callback) => {
                        if (value.list.length === 0) {
                          callback(new Error('请选择标题'));
                        } else {
                          callback();
                        }
                      },
                    },
                  ],
                  value: {
                    list: [],
                  },
                },
                /** 小游戏链接 */
                mini_program_info_url: {
                  label: '小游戏链接',
                  type: 'input',
                  hidden: true,
                  value: '',
                  props: {
                    disabled: true,
                  },
                  rules: [
                    { required: true, message: '请选择小游戏链接', trigger: ['blur', 'change'] },
                  ],
                },
                /** 普通落地页链接素材 */
                external_url_material_list: {
                  label: '落地页',
                  type: 'input-list',
                  hidden: true,
                  value: [],
                  props: {
                    maxCount: 10,
                  },
                  rules: {
                    required: true, trigger: [],
                    validator: (rule, value, callback) => {
                      if (value.length === 0) {
                        callback(new Error('至少添加一个'));
                      } else {
                        callback();
                      }
                    },
                  },
                },
                /** Android应用下载详情页（用户点击广告中“立即下载”按钮以外的区域时所到达的页面），上限10个 */
                web_url_material_list: {
                  label: 'Android应用下载详情页',
                  type: 'input-list',
                  hidden: true,
                  value: [],
                  props: {
                    maxCount: 10,
                  },
                  rules: {
                    required: true, trigger: [],
                    validator: (rule, value, callback) => {
                      if (value.length === 0) {
                        callback(new Error('至少添加一个'));
                      } else {
                        callback();
                      }
                    },
                  },
                },
              },
            },
          },
        },
        // 出价运算
        budget_and_bid_form: {
          title: '广告预算与出价',
          hidden: false,
          config: {
            /**
             * 预算(出价方式为OCPM时，不少于300元；24小时内修改预算操作，不能超过20次，24小时是指自然天的24小时；单次修改预算幅度不能低于100元（增加或者减少）；修改后预算金额，不能低于当前已消费金额的105%，以整百单位向上取整；取值范围: ≥ 0
             */
            budget: {
              label: '预算',
              type: 'input-number',
              value: 0,
              props: {
                disabled: false,
                min: 300,
              },
              hidden: false,
            },
            /**
             * 目标转化出价/预期成本， 取值范围：0.1-10000元
             * 注意：当 bid_type = NO_BID时，不填写该字段，否则会报错
             */
            cpa_bid: {
              label: '目标转化出价',
              type: 'input-number',
              value: 0,
              hidden: false,
              props: {
                min: 0.1,
                max: 10000,
              },
            },
            /**
             * 深度优化出价，deep_bid_type = DEEP_BID_MIN 时必填。取值范围：0.1~10000元
             * 注意：当 bid_type = NO_BID时，不填写该字段，否则会报错
             */
            deep_cpabid: {
              label: '深度优化出价',
              type: 'input-number',
              hidden: true,
              value: '',
            },
            /**
             * 深度转化ROI系数, 范围(0,5]，精度：保留小数点后四位，当 deep_bid_type = ROI_COEFFICIENT 时必填
             * 注意：当 bid_type=NO_BID时，不填写该字段，否则会报错
             */
            roi_goal: {
              label: '深度转化ROI系数',
              type: 'input-number',
              hidden: true,
              value: '',
            },
          },
        },
        // 产品信息
        product_info_form: {
          title: ' 产品信息',
          config: {
            product_info: {
              value: {},
              children: {
                titles: {
                  label: '产品名称',
                  type: 'input-list',
                  props: {
                    min: 1,
                    max: 20,
                  },
                  rules: {
                    required: true, trigger: [],
                    validator: (rule, value, callback) => {
                      if (value.length === 0) {
                        callback(new Error('产品名称至少添加一个'));
                      } else {
                        callback();
                      }
                    },
                  },
                  value: [],
                },
                image_ids: {
                  label: '产品主图',
                  // 限制数量
                  limit: 10,
                  is_open: false,
                  box_type: 'image',
                  temp_material: null,
                  value: {
                    images: [],
                    tab: 'image',
                  },
                  rules: {
                    required: true, trigger: [],
                    validator: (rule, value, callback) => {
                      if (value.images.length !== 0) {
                        callback();
                      } else {
                        callback(new Error('请选择产品主图'));
                      }
                    },
                  },
                },
                selling_points: {
                  label: '产品卖点',
                  type: 'input-list',
                  value: [],
                  props: {
                    min: 6,
                    max: 9,
                  },
                  rules: {
                    required: true, trigger: [],
                    validator: (rule, value, callback) => {
                      if (value.length === 0) {
                        callback(new Error('产品卖点至少添加一个'));
                      } else {
                        callback();
                      }
                    },
                  },
                },
              },
            },
            // 行动号召文案
            call_to_action_buttons: {
              label: '行动号召文案',
              type: 'input-list',
              value: [],
              props: {
                min: 2,
                max: 6,
              },
              rules: {
                required: true, trigger: [],
                validator: (rule, value, callback) => {
                  if (value.length === 0) {
                    callback(new Error('行动号召文案至少添加一个'));
                  } else {
                    callback();
                  }
                },
              },
            },
          },
        },
        // 附加创意信息-表单配置
        additional_creative_info_form: {
          title: '附加创意信息',
          config: {
            /** 广告来源，字数限制：[2-10]（英文字符限制：[4-20]）当landing_type = LINK、MICRO_GAME、SHOP时必填  */
            source: {
              label: '广告来源',
              type: 'input',
              value: '',
              rules: {
                required: true,
                trigger: ['change'],
                validator: (rule, value, callback) => {
                  let len = 0;
                  for (let i = 0; i < value.length; i++) {
                    // 识别中文字符则长度+2，其余字符长度+1
                    if (value.charAt(i).match(/[\u4e00-\u9fa5]/g) != null) {
                      len += 2;
                    } else {
                      len += 1;
                    }
                  }
                  const { landing_type } = this.project_batch_params[this.project_index].basic_set_form.config;
                  /** 字符长度为0且推广目标不是小游戏时允许通过验证 */
                  if (len === 0 && landing_type.value !== 'MICRO_GAME') {
                    callback();
                  } else if (len > 20 || len < 4) {
                    callback(new Error('字数限制：[2-10]（英文字符限制：[4-20]）'));
                  } else {
                    callback();
                  }
                },
              },
            },
          },
        },
        // 原生锚点
        anchor_material_list_form: {
          title: '原生锚点',
          config: {
            anchor_related_type: {
              label: '原生锚点',
              type: 'radio-group',
              value: 'OFF',
              isButton: true,
              disabled: true,
              options: [{
                label: '不启用',
                value: 'OFF',
              },
              {
                label: '自动生成',
                value: 'AUTO',
              },
              {
                label: '手动选择',
                value: 'SELECT',
                disabled: false,
              }],
              rules: [
                { required: true, message: '请选择原生锚点', trigger: ['blur', 'change'] },
              ],
            },
            anchor_material_list: {
              value: {},
              children: {
                anchor_type: {
                  label: '锚点类型',
                  type: 'select',
                  hidden: true,
                  value: '',
                  props: {
                    placeholder: '请选择锚点类型',
                    filterable: true,
                    style: {
                      width: '200px',
                    },
                  },
                  options: [
                    { label: '应用下载-游戏', value: 'APP_GAME' },
                    { label: '应用下载-网服', value: 'APP_INTERNET_SERVICE' },
                    { label: '应用下载-电商', value: 'APP_SHOP' },
                    { label: '高级在线预约', value: 'ONLINE_SUBSCRIBE' },
                  ],
                  rules: [
                    { required: true, message: '请选择锚点类型', trigger: ['blur', 'change'] },
                  ],
                },
                anchor_id: {
                  label: '锚点ID',
                  type: 'select',
                  hidden: true,
                  value: '',
                  props: {
                    placeholder: '请选择锚点ID',
                    filterable: true,
                    style: {
                      width: '200px',
                    },
                  },
                  options: [],
                  rules: [
                    { required: true, message: '请选择锚点ID', trigger: ['blur', 'change'] },
                  ],
                },
              },
            },
          },
        },
      };
    },
    /** 获取行政区域列表 */
    getDistrict(advertiser_id) {
      return new Promise((resolve, reject) => {
        getDistrictApi({ advertiser_id, codes: ['CN'], language: 'ZH_CN_GOV', sub_district: 'THREE_LEVEL' }).then(resolve).catch(reject);
      });
    },
    /**
     * 生成行政区域数据所需结构
     * @param {object[]} sources 行政区域源数据
     * @param {object[]} target 行政区域数据所需结构
     */
    generateDistrictsSchema(sources, target) {
      sources.forEach(district => {
        const { code: id, name, sub_districts } = district;
        const temp_data = { id, name, label: name, ...(sub_districts && { children: [] }) };
        target.push(temp_data);
        sub_districts && this.generateDistrictsSchema(sub_districts, temp_data.children);
      });
    },
    /* 初始化行政区域数据 */
    async initDistrict(advertiser_id) {
      if (!this.districts_map[advertiser_id] && advertiser_id) {
        try {
          const { districts, version } = await this.getDistrict(advertiser_id);
          const [cn_districts] = districts;
          const local_districts = [];
          this.generateDistrictsSchema(cn_districts.sub_districts, local_districts);
          this.$set(this.districts_map, advertiser_id, { districts: local_districts, version: [{ label: version, value: version }] });
        } catch {
          this.$delete(this.districts_map, advertiser_id);
        }
      }
    },
    /** 初始化账号所属的行政区域数据 */
    async initDistrictTasks() {
      for (let index = 0; index < this.project_batch_params.length; index++) {
        const { advertiser_id } = this.project_batch_params[index];
        await this.initDistrict(advertiser_id);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-tabs__new-tab {
  border: none;
  height: 30px;
  width: 30px;
  line-height: 32px;
  font-size: 24px;
  margin: 0px;
  color: #fff;
  background-color: #1890ff;
  &:hover {
    background-color: #46a6ff;
  }
}
</style>
